/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{-ms-flex:1 1 auto;flex:1 1 auto;display:-ms-flexbox;display:flex;padding:24px}.header[_ngcontent-%COMP%]{-ms-flex-align:center;align-items:center}.fullsize[_ngcontent-%COMP%]{-ms-flex:1 1 auto;flex:1 1 auto}app-stack-layout[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{-ms-flex-negative:0;flex-shrink:0}.on-tr-hover[_ngcontent-%COMP%]{opacity:0;transition:opacity .3s}tr[_ngcontent-%COMP%]:hover   .on-tr-hover[_ngcontent-%COMP%]{opacity:1}.on-tr-hover-force[_ngcontent-%COMP%]{opacity:1!important}"];
export { styles as styles };
